
import React from 'react';

import _ from 'lodash';

import Panel from 'omega-rtc/views/ucd/Panel';
import { Col, Row } from 'grab-ui';
import UCDObjectiveLabel from 'omega-rtc/components/form/ucd/common/UCDObjectiveLabel';
import {
  FIELD_TYPE,
  NUMBER_FORMAT,
} from 'omega-rtc/constants/ucd';
import numeral from 'numeral';


const BusinessMetricsPanel = ({ objective, subObjective, campaignBizMetricsColumns, businessMetrics }) => {
  return (
    <Panel title={'Business Metrics'} showDownloadButton={false}>
      <Row className={'goals-row'}>
        <Col span={6}>
          <p>Goals</p>
          <UCDObjectiveLabel objective={objective} subObjective={subObjective} />
        </Col>
      </Row>
      <Row className="project-page-metrics-topbar campaign-page-metrics-topbar">
        <table>
          <tr>
            {campaignBizMetricsColumns.map((column, index) => {
              const value = _.get(businessMetrics, column.key, 0);
              const format = (column.type === FIELD_TYPE.CURRENCY
                ? NUMBER_FORMAT.CURRENCY
                : NUMBER_FORMAT.INTEGER);
              const isTextBold = index === 0;
              const numValue = column.type === FIELD_TYPE.CURRENCY ? value : _.ceil(value);

              const formattedNumber = isTextBold
                ? (<strong><p>{numeral(numValue).format(format)}</p></strong>)
                : (<p>{numeral(numValue).format(format)}</p>);

              return (
                <td>
                  <span>{column.title}</span>
                  {formattedNumber}
                </td>
              );
            })}
          </tr>
        </table>
      </Row>
    </Panel>
  );
};

export default BusinessMetricsPanel;
